import { Box, Typography } from "@mui/material";
import React from "react";
import loginimage from "../../../assest/images/logipagebg1.png";
import SignInputField from "./SignInputField";
import logo from "../../../assest/images/meefoodlogo.png";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../../../layoutcontainers/PageLayout";

const SignIn = () => {
  const navigate = useNavigate();

  return (
    <PageLayout disableFooter showNavbar>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${loginimage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: { xs: "20px 15px", md: "35px 20px 20px" },
          overflowY: "auto",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 1,
          },
        }}
      >


        {/* Semi-transparent Glass Card */}
        <Box
          sx={{
            zIndex: 2,
            width: "100%",
            maxWidth: "420px",
            backgroundColor: "rgba(0, 0, 0, 0.42)",
            borderRadius: "6px",
            boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            padding: { xs: "30px 24px", sm: "40px 36px 32px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: "auto",
          }}
        >
          {/* Profile Circle with mefood-fav.png */}
          <Box
            sx={{
              width: "78px",
              height: "78px",
              borderRadius: "50%",
              backgroundColor: "#ffffff",
              padding: "3px",
              border: "3px solid rgba(255, 255, 255, 0.8)",
              boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              mb: 1.5,
            }}
          >
            <img
              src={logo}
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "contain",
              }}
            />
          </Box>


          <Typography
            sx={{
              color: "#ffffff",
              fontSize: "17px",
              fontWeight: 400,
              letterSpacing: "0.5px",
              mb: 3,
              textAlign: "center",
            }}
          >
            Welcome Back !
            <br />
            Sign in to continue to Me Food !
          </Typography>

          {/* Input Fields & Submit */}
          <SignInputField />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            zIndex: 2,
            textAlign: "center",
            width: "100%",
            pb: 1,
            mt: 2,
          }}
        >
          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: { xs: "12px", sm: "13px" },
              letterSpacing: "0.5px",
            }}
          >
            © {new Date().getFullYear()}. All rights reserved |{" "}
            <span
              onClick={() => navigate("/privacy-policy")}
              style={{
                color: "#25d366",
                cursor: "pointer",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Privacy Policy
            </span>
          </Typography>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default SignIn;
